import { z } from 'zod';
import { DefaultPackagePayment } from '@pages/Default';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/default/payment')({
  component: DefaultPackagePayment,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
